import React, { useState, useContext, useEffect } from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Checkbox } from "@mui/material";
import FuncionesContext, {
  getAtributo,
} from "../../../context/FuncionesContext";
import PantallaContext from "../../../context/PantallaContext";

const CheckboxC = ({ data, cab, campokey, id_elemento }) => {
  const { superSubmit } = useContext(FuncionesContext);
  const { configuraciones_ref } = useContext(PantallaContext);

  const [value, setValue] = useState(data[campokey]);
  const [lastValue, setLastvalue] = useState(data[campokey]);
  const [update_id, setUpdate_id] = useState(data[cab.update_id_alias]);

  const claveEnvio = (() => {
    const clave = data[`${cab.id_a}_clave_envio`] ?? cab.clave_envio;
    return typeof clave === "string" && clave.trim() !== "" ? clave : null;
  })();

  const nombre = (() => {
    if (cab.nombre_alias) {
      return data[cab.nombre_alias];
    }
    return cab.nombre;
  })();

  const handleCancelar = () => {
    document.body.style.cursor = "default";
    setValue(lastValue);
    // setLastvalue(data[campokey]);
  };

  const handleChange = async (e) => {
    const valor = e.target.checked ? "s" : "n";

    //console.log("avhe", valor);

    if (valor === null || lastValue?.toString() === valor.toString().trim())
      return;

    const { id_a } = cab;

    setValue(valor);
    if (claveEnvio) data[claveEnvio] = valor;

    try {
      superSubmit({ valor, id_a, update_id, handleCancelar, cab, data })
        .then((result) => {
          setLastvalue(valor);
        })
        .catch((err) => {
          // console.log("Error supersubmit CHECKBOX")
          handleCancelar();
        });
    } catch (err) {
      console.log(err);
      return;
    }
  };

  useEffect(() => {
    setValue(data[campokey]);
    setUpdate_id(data[cab.update_id_alias]);
  }, [configuraciones_ref[cab.id_a]]);

  return (
    <div
      className="cfsf_checkbox"
      id={id_elemento}
      style={{ marginLeft: "14px", display: "flex" }}
    >
      <FormControlLabel
        control={
          <Checkbox
            checked={value === "s" ? true : false}
            onChange={handleChange}
            disabled={getAtributo("disabled", data, cab) === "s"}
          />
        }
        label={cab.label}
        className={cab.className}
      />
      {nombre && !cab.label ? (
        <div className="vista_label_checkbox">{nombre} </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default CheckboxC;
